import { PlansService } from '@dtx-company/connect-codegen/src/gen/plans/v1/plans_connect'
import { PromiseClient, createPromiseClient } from '@bufbuild/connect'
import { createConnectTransport } from '@bufbuild/connect-web'

const plansClient: PromiseClient<typeof PlansService> = createPromiseClient(
  PlansService,
  createConnectTransport({
    baseUrl: process.env.PLANS_SERVICE || '',
    credentials: 'include'
  })
)

export default plansClient
